import Vue from "vue";

class ErrorHelper extends Vue {
    message(e, alterMsg) {
        let msg = alterMsg;

        if (e && e.response) {
            const response = e.response;

            if (response.status !== 200 && response.data) {
                const data = response.data;

                if (data.message && data.message !== "") {
                    msg = data.message;
                } else if (data.errorMessage && data.errorMessage !== "") {
                    msg = data.errorMessage;
                }
            }
        }

        return msg;
    }

    // Backend errors may carry raw upstream payloads (JSON, stack traces). Only surface a short,
    // human-readable message to the user; fall back otherwise so we never dump system internals in a toast.
    safeMessage(e, fallback) {
        const msg = this.message(e, null);
        if (!msg || msg.length > 160 || msg.indexOf("{") !== -1) {
            return fallback;
        }
        return msg;
    }

    isSessionExpired(e) {
        if (e && e.response && e.response.status && e.response.status == 401) {
            window.dispatchEvent(
                new CustomEvent("check-logout", {
                    detail: {
                        storage: e,
                    },
                    from: "isSessionExpired",
                })
            );
            return true;
        } else {
            return false;
        }
    }

    signInError(e) {
        if (!e || !e.response || !e.response.data) {
            return "messages.sign-in-error-default";
        }
        let code = e.response.data.status;
        let msg = e.response.data.message;
        if (code == 403) {
            switch (msg) {
                case "UnverifiedUser":
                    return "messages.send-user-email";
                case "BlockedUser":
                    return "messages.sign-in-403-BlockedUser";
                default:
                    return "messages.sign-in-error-default";
            }
        }
        return "messages.sign-in-error-default";
    }

    signUpError(code) {
        switch (code) {
            case (302, 409):
                return "messages.sign-up-" + code;
            default:
                return "sign-up-error-default";
        }
    }
}

export default new ErrorHelper();
